export function getDownloadedReviewedSku(downloadSkus, reviewedSkus) {
	return (
		reviewedSkus &&
		downloadSkus &&
		downloadSkus.filter(item => reviewedSkus.includes(item))
	);
}

export function getDownloadedNotReviewedSku(downloadSkus, reviewedSkus) {
	if (downloadSkus && !reviewedSkus) {
		return downloadSkus;
	} else {
		return (
			reviewedSkus &&
			downloadSkus &&
			downloadSkus.filter(item => !reviewedSkus.includes(item))
		);
	}
}
